<template>
  <div class="common-btn" :class="{disabled}">
    <slot>{{text}}</slot>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: '按钮'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  }
}
</script>
<style lang="scss" scoped>
  .common-btn {
    display: inline-block;
    background: linear-gradient(223deg, #8c7bff 0%, #5a72f4 64%, #476eef 100%);
    border-radius: 4px;
    width: 264px;
    height: 44px;
    line-height: 44px;
    font-size: 14px;
    color: #fff;
    text-align: center;
    cursor: pointer;
    user-select: none;
  }
  .common-btn.disabled {
    opacity: .5;
    pointer-events: none;
  }
</style>



// WEBPACK FOOTER //
// src/views/pc/Login/components/Button.vue